import { render, staticRenderFns } from "./PricingCountChip.vue?vue&type=template&id=1096ea4d&scoped=true"
import script from "./PricingCountChip.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingCountChip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PricingCountChip.vue?vue&type=style&index=0&id=1096ea4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1096ea4d",
  null
  
)

export default component.exports